import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Error404 = () => {
 return (
  <Card className="text-center">
   <Card.Body className="p-5">
    <div className="display-1 text-300 fs-error">404</div>
    <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">La página que estas buscando No Existe por el momento.</p>
    <hr />
    <p>
     Asegurate que la direccion o Url sea la correcta y que la pagina no haya sido removida,si pinesas que es un error del
     sistema...
     <a href="mailto:info@exmaple.com" className="ms-1">
      Contáctanos
     </a>
     .
    </p>
    <Link className="btn btn-primary btn-sm mt-3" to="/">
     <FontAwesomeIcon icon={faHome} className="me-2" />
     Ir al Inicio
    </Link>
   </Card.Body>
  </Card>
 );
};

export default Error404;
